import React from 'react';
import { Description, labelColor, labelSize } from 'views/mutual/description';

export const LotInputCommonDescriptions = () => (
  <>
    <Description
      label="※申込単位は、10個1,000万円となります。"
      labelColor={labelColor.gray}
      labelSize={labelSize.small}
    />
    <Description
      label="※ご購入に際しては、信託不動産価格以外に、建物消費税、修繕積立金、必要運転資金留保金の相当額の合計を信託受益権売買代金としてお支払いいただくほか、諸経費として確定日付取得費用が掛かります。"
      labelColor={labelColor.gray}
      labelSize={labelSize.small}
    />
    <Description
      label="※登記を希望される方は対面（書面）でのお手続きが必要であるため、オンラインでお申し込みを承ることができません。お問い合わせフォームからご連絡をお願いいたします。"
      labelColor={labelColor.gray}
      labelSize={labelSize.small}
    />
  </>
);
